import { render, staticRenderFns } from "./PbConfirm.vue?vue&type=template&id=16689f85&"
import script from "./PbConfirm.vue?vue&type=script&lang=js&"
export * from "./PbConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PbConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports